import { useCallback, useMemo } from "react";
import { StoreOption, useStoreOptions } from "./use-store-options";

/**
 * Danh mục sản phẩm / dịch vụ / bảng giá / dịch vụ kèm dùng CHUNG cho mọi chi nhánh lưu với branch_id = 0
 * (product service: common/branch-scope.ts). Chi nhánh vẫn có thể có dòng riêng cho sản phẩm danh mục chung không có.
 */
export const ALL_BRANCHES_VALUE = 0;
export const ALL_BRANCHES_LABEL = "Dùng chung (tất cả chi nhánh)";

/**
 * Chi nhánh cho các màn quản lý danh mục: như useStoreOptions, thêm lựa chọn "Dùng chung" (branch_id = 0)
 * lên đầu.
 *
 * "Dùng chung" LUÔN có mặt, không phụ thuộc quyền: danh mục đang vận hành dùng chung nên mọi dòng tạo mới
 * phải mang branch_id = 0, còn quyền tạo/sửa do BE kiểm tra (product service, @Privileges). Trước đây chỉ
 * ADMIN mới có lựa chọn này → với người khác, modal tạo thấy 0 không nằm trong danh sách nên tự đổi sang chi
 * nhánh đầu tiên, tạo ra dòng riêng chi nhánh không hiện trên màn (màn chỉ tải dòng dùng chung).
 */
export const useCatalogBranchOptions = () => {
  const { options: branchOptions, loading, error } = useStoreOptions();

  const options = useMemo<StoreOption[]>(
    () => [{ value: ALL_BRANCHES_VALUE, label: ALL_BRANCHES_LABEL }, ...branchOptions],
    [branchOptions],
  );

  /** Tên hiển thị cho branch_id của một dòng (0 → "Dùng chung"). */
  const branchLabel = useCallback(
    (branchId?: number | null) => {
      if (Number(branchId) === ALL_BRANCHES_VALUE) return ALL_BRANCHES_LABEL;
      return branchOptions.find((o) => Number(o.value) === Number(branchId))?.label ?? `Store #${branchId}`;
    },
    [branchOptions],
  );

  return { options, branchOptions, loading, error, branchLabel };
};
